var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictoCoworking(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 49.021,
    height: 48,
    viewBox: "0 0 49.021 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .prefix__cls-2{fill:none;stroke:#898e9a;stroke-linecap:round;stroke-miterlimit:10}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__pict-cowork",
    transform: "translate(-11.5 -11)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "prefix__Rectangle_359",
    width: 48,
    height: 48,
    fill: "none",
    "data-name": "Rectangle 359",
    rx: 2,
    transform: "translate(12 11)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__ico-cowork",
    transform: "translate(12 19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "prefix__Groupe_87",
    "data-name": "Groupe 87",
    transform: "translate(1.136)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_130",
    d: "M248.9 521.2c3.7-1.373 4.062-3.616 3.512-5.048s-1.047-2.394-2.032-4.441-2.594-3.048-6.5-3.048h-3.78c-3.906 0-5.514 1-6.5 3.048s-1.482 3.01-2.032 4.441-.19 3.675 3.512 5.048",
    className: "prefix__cls-2",
    "data-name": "Trac\\xE9 130",
    transform: "translate(-231.36 -496.745)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_131",
    d: "M238.966 527.163v-8.171a1.248 1.248 0 0 1 1.248-1.248h8.574a1.248 1.248 0 0 1 1.248 1.248v8.171",
    className: "prefix__cls-2",
    "data-name": "Trac\\xE9 131",
    transform: "translate(-233.884 -499.756)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_10",
    cx: 5.128,
    cy: 5.128,
    r: 5.128,
    className: "prefix__cls-2",
    "data-name": "Ellipse 10",
    transform: "translate(5.44)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_11",
    cx: 0.928,
    cy: 0.928,
    r: 0.928,
    className: "prefix__cls-2",
    "data-name": "Ellipse 11",
    transform: "translate(10.825 21.165)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "prefix__Groupe_88",
    "data-name": "Groupe 88",
    transform: "translate(25.639)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_132",
    d: "M285.57 521.2c3.7-1.373 4.062-3.616 3.512-5.048s-1.047-2.394-2.032-4.441-2.594-3.048-6.5-3.048h-3.784c-3.906 0-5.514 1-6.5 3.048s-1.482 3.01-2.032 4.441-.19 3.675 3.512 5.048",
    className: "prefix__cls-2",
    "data-name": "Trac\\xE9 132",
    transform: "translate(-268.029 -496.745)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_133",
    d: "M275.635 527.163v-8.171a1.248 1.248 0 0 1 1.248-1.248h8.574a1.248 1.248 0 0 1 1.248 1.248v8.171",
    className: "prefix__cls-2",
    "data-name": "Trac\\xE9 133",
    transform: "translate(-270.553 -499.756)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_12",
    cx: 5.128,
    cy: 5.128,
    r: 5.128,
    className: "prefix__cls-2",
    "data-name": "Ellipse 12",
    transform: "translate(5.44)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "prefix__Ellipse_13",
    cx: 0.928,
    cy: 0.928,
    r: 0.928,
    className: "prefix__cls-2",
    "data-name": "Ellipse 13",
    transform: "translate(35.329 21.165)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Trac\\xE9_134",
    d: "M229.661 535.666V533.6a1.71 1.71 0 0 1 1.71-1.709h44.6a1.709 1.709 0 0 1 1.709 1.709v2.063",
    className: "prefix__cls-2",
    "data-name": "Trac\\xE9 134",
    transform: "translate(-229.661 -504.45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictoCoworking);
export default __webpack_public_path__ + "static/media/picto-coworking.69088b89f428842b6cfa6a8f413a45db.svg";
export { ForwardRef as ReactComponent };